<template>
    <a-modal
    centered
        :visible="visible"
        title="修改发票信息"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" :label-width="150">

            <a-form-model-item>
                  <a-radio-group v-model="form.invoice_type" button-style="solid">
                    <a-radio-button value="receipt">收据</a-radio-button>
                    <a-radio-button value="special">增值税专业发票</a-radio-button>
                    <a-radio-button value="normal">增值税普通发票</a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="公司抬头">
                <a-input v-model="form.title"></a-input>
            </a-form-model-item>

            <a-form-model-item label="纳税人识别码">
                <a-input v-model="form.id_code"></a-input>
            </a-form-model-item>

            <a-form-model-item label="开户行信息">
                <a-input v-model="form.bank_name"></a-input>
            </a-form-model-item>

            <a-form-model-item label="开户行账号">
                <a-input v-model="form.bank_no"></a-input>
            </a-form-model-item>

            <a-form-model-item label="企业注册地址">
                <a-input v-model="form.reg_address"></a-input>
            </a-form-model-item>

            <a-form-model-item label="电话号码">
                <a-input v-model="form.tel"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        invoice_type:null,
        title: null,
        id_code: null,
        bank_name: null,
        bank_no: null,
        reg_address: null,
        tel: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            callback:null,
            record: null,
        },

        data() {
            return {
                submitting: false,
                form: {},
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },

            on_submit() {
                this.submitting = true;
                this.$http
                    .put("/finance/invoice_review/" + this.record.id, this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            if(this.callback)
                            {
                                this.callback()
                            }
                        } else {
                            this.$error({ title: "失败", content: res.message });
                        }
                    })
                    .catch(() => {})

                    .then(() => {
                        this.submitting = false;
                    });
            },

            after_close() {
                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
